export function BackgroundSVG() {
    return (
        <svg width="100%" height="100%" id="background-svg" preserveAspectRatio="none" viewBox="0 0 900 400" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="background">
                <path id="Vector 3" d="M1366 656H0V286.152L204.5 259.125L352.5 152.438L533.5 91.2705L748.5 152.438L935 81.3131L1207 32L1366 59.0274V300.851V656Z" fill="#F14964" fillOpacity="0.7" />
                <path id="Vector 1" d="M177.5 537.933L0 656H1366V385.726L1290.5 364.863H1152.5L884.5 422.237L699 385.726L426.5 501.897L177.5 537.933Z" fill="#F14964" fillOpacity="1" />
                <path id="Vector 2" d="M326 379.088L111 416.073L0 472.024V656H1366V221.666L1216.5 210.286L996.5 221.666L805.5 294.687L544.5 254.383L326 379.088Z" fill="#F14964" fillOpacity="0.6" />
            </g>
        </svg>
    )
}